import React from 'react';

import StockFilterMultiSelect from '@/components/StockFilterMultiSelect';
import { OptionType } from '@/typings/common';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  getStockFilterParams,
  setCarEngineTypes,
  setPage,
} from '@/store/reducers/cars-stock';
import {
  convertFilterParamsToOptionsByKey,
  handleChangeMultiSelect,
} from '@/modules/CarsStock/components/common.helpers';

function EngineTypeFilter() {
  const dispatch = useTypedDispatch();
  const stockFilterParams = useTypedSelector(getStockFilterParams);
  const selectedEngineTypes =
    useTypedSelector(getSelectedFilters).selectedParams.selectedEngineType;

  const engineTypeOptions = convertFilterParamsToOptionsByKey(
    stockFilterParams,
    'fuelTypes'
  );

  const handleChangeEngineType = (engineType: OptionType) => {
    dispatch(
      setCarEngineTypes(
        handleChangeMultiSelect(engineType, selectedEngineTypes)
      )
    );
    dispatch(setPage(1));
  };

  const handleClearEngineType = () => {
    dispatch(setCarEngineTypes([]));
    dispatch(setPage(1));
  };

  return (
    <StockFilterMultiSelect
      label="Двигатель"
      options={engineTypeOptions}
      selectedOptions={selectedEngineTypes}
      onChange={handleChangeEngineType}
      onClear={handleClearEngineType}
    />
  );
}

export default EngineTypeFilter;
